import { BUILD_CATALOG, isIncomeKind, purchaseCost } from '../config/catalog';
import type { EntityKind, ParkState } from '../types';
import { evaluateCatalogUnlock } from './unlocks';

export function ownsIncomeEntity(state: ParkState): boolean {
  return state.entities.some((entity) => isIncomeKind(entity.kind));
}

export function cheapestUnlockedIncomePurchase(
  state: ParkState,
): { kind: EntityKind; cost: number; name: string } | null {
  let best: { kind: EntityKind; cost: number; name: string } | null = null;
  for (const item of BUILD_CATALOG) {
    if (!isIncomeKind(item.kind) || !evaluateCatalogUnlock(item.kind, state).ok) {
      continue;
    }
    const cost = purchaseCost(item.kind);
    if (best === null || cost < best.cost) {
      best = { kind: item.kind, cost, name: item.name };
    }
  }
  return best;
}

export function wouldBreakIncomeReserve(state: ParkState, kind: EntityKind): boolean {
  if (ownsIncomeEntity(state) || isIncomeKind(kind)) {
    return false;
  }
  const reserve = cheapestUnlockedIncomePurchase(state);
  if (!reserve) {
    return false;
  }
  return state.coins - purchaseCost(kind) < reserve.cost;
}

export function incomeReserveBlockReason(state: ParkState, kind: EntityKind): string | null {
  if (!wouldBreakIncomeReserve(state, kind)) {
    return null;
  }
  const reserve = cheapestUnlockedIncomePurchase(state);
  if (!reserve) {
    return null;
  }
  return `Keep coins for ${reserve.name}`;
}
